import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

// Delete de paciente servido pelo quarkus.
export function useDeletePatient() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((patientId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/patients/${patientId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
